module.exports = __webpack_public_path__ + "img/intexternal.6029772b.svg";